/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_021f3bba"]'><div :class='[("slot-item "+(activeClass))]'><div :class='["slot-item-text"]'>{{ index + 1 }}{{ txt }}</div></div></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_021f3bba"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_021f3bba"}
  /** script content **/
  require("./item-renderer.mpx.js?isComponent&outputPath=components%2Fitem-renderer021f3bba%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./item-renderer.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fitem-renderer021f3bba%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_021f3bba"],
    ctorType: "component",
    outputPath: "components/item-renderer021f3bba/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>